export const DEFAULT_STUDY_TAB = 'ai-tutor';

export const STUDY_TAB_CONFIG = {
  'ai-tutor': {
    id: 'ai-tutor',
    label: 'AI Tutor',
    canonicalPath: '/ai-tutor',
    compatibilityPath: '/study/ai-tutor',
  },
  flashcards: {
    id: 'flashcards',
    label: 'Flashcards',
    canonicalPath: '/flashcards',
    compatibilityPath: '/study/flashcards',
  },
  'revision-tracker': {
    id: 'revision-tracker',
    label: 'Study Tracker',
    canonicalPath: '/revision-tracker',
    compatibilityPath: '/study/revision-tracker',
  },
};

export const STUDY_TAB_IDS = Object.keys(STUDY_TAB_CONFIG);

export const DEFAULT_STUDY_ROUTE = STUDY_TAB_CONFIG[DEFAULT_STUDY_TAB].canonicalPath;

export function isStudyTab(tab) {
  return STUDY_TAB_IDS.includes(String(tab || '').trim().toLowerCase());
}

export function normalizeStudyTab(tab, fallback = DEFAULT_STUDY_TAB) {
  const normalized = String(tab || '').trim().toLowerCase();
  return isStudyTab(normalized) ? normalized : fallback;
}

export function getStudyRoute(tab = DEFAULT_STUDY_TAB) {
  return STUDY_TAB_CONFIG[normalizeStudyTab(tab)].canonicalPath;
}

export function getCompatibilityStudyRoute(tab = DEFAULT_STUDY_TAB) {
  return STUDY_TAB_CONFIG[normalizeStudyTab(tab)].compatibilityPath;
}

export function getLegacyStudyRoute(tab = DEFAULT_STUDY_TAB) {
  return getCompatibilityStudyRoute(tab);
}

export function getStudyTabFromPath(pathname, fallback = null) {
  const normalizedPath = String(pathname || '').trim();
  const matchedTab = STUDY_TAB_IDS.find((tabId) => {
    const tabConfig = STUDY_TAB_CONFIG[tabId];
    return normalizedPath === tabConfig.canonicalPath || normalizedPath === tabConfig.compatibilityPath;
  });

  return matchedTab || fallback;
}

export function isCanonicalStudyRoute(pathname) {
  const normalizedPath = String(pathname || '').trim();
  return STUDY_TAB_IDS.some((tabId) => normalizedPath === STUDY_TAB_CONFIG[tabId].canonicalPath);
}

export function getCanonicalStudyRouteFromPath(pathname) {
  const matchedTab = getStudyTabFromPath(pathname);
  return matchedTab ? getStudyRoute(matchedTab) : null;
}

export function isStudyRoute(pathname) {
  return Boolean(getCanonicalStudyRouteFromPath(pathname));
}
